module.exports = __webpack_public_path__ + "static/media/notaNV.0b0bd8e5.svg";